<template>
  <v-layout wrap>
    <v-container>
      <v-flex xs12><div class="subheader black--text">Logics</div></v-flex>
      <v-flex xs12 sm6 md12>
        <v-card class="white--text mb-2" v-for="(logic_group, logic_group_index) in question_logic"
          v-bind:key="logic_group_index">
          <v-card-title class="red--background  right" primary-title>
            <div>
              <div class="subheader black--text  right">{{ getGroupName(logic_group_index) }}</div>
            </div>
          </v-card-title>
          <v-layout row>
            <v-card-text> 
              <div xs12 class="previous" v-for="(logic, logic_index) in logic_group.logic_set" v-bind:key="logic_index">
                <v-layout class="mb-2">
                  <v-flex xs6>
                    <span class="black--text">  {{ questionName(logic) }} </span>
                  </v-flex>
                  <v-flex xs3 class="black--text">
                     {{ getLogicOperator(logic) }}
                  </v-flex>
                  <v-flex xs3 class="black--text">
                    {{ logic.logic_input }}
                  </v-flex>
                </v-layout>
                
              </div>
            </v-card-text>
          </v-layout>
        </v-card>
      </v-flex>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: { 
    question_logic:[], 
    questions:[],
    "counter_index":Number,
    },
  data: () => ({
    questionLogic:'',
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    binding() {
      const binding = {};
      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },
  },

  created() {
    // this.$store.dispatch("setIndexData", [this.apiUrl]);
    // this.editedData();
    // this.questionLogic=JSON.parse(this.question_logic);
    // console.log(this.questionLogic);
    // console.log(this.questions);
  },

  methods: {
    getGroupName(group_index){
      return "Logic group - "+(group_index + 1);
    },
    questionName(logic){
      var variable_index = this.questions.findIndex(x => x.question_variable === logic.q_index);
      // console.log(this.questions);
      return this.questions[variable_index].question;
    },
    getLogicOperator(logic){
      var logic_operator_name = "";
      logic.logic_operator.forEach(element => {
        if(element.id == logic.logic_operator_id){
          logic_operator_name = element.name;
        }
      });
      // console.log(logic);
      return logic_operator_name;
    },
  },
};
</script>

<style scoped>
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
</style>